import { render, staticRenderFns } from "./Blocks.vue?vue&type=template&id=6c2d50c4&scoped=true"
import script from "./Blocks.vue?vue&type=script&lang=js"
export * from "./Blocks.vue?vue&type=script&lang=js"
import style0 from "./Blocks.vue?vue&type=style&index=0&id=6c2d50c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2d50c4",
  null
  
)

export default component.exports